import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { AppAnalysisService } from '../../../../../src/app/app-analysis-module/app-analysis.service';
import { PricingModalComponent } from '../../../../lib-pricing/src/lib/pricing-modal/pricing-modal.component';
import { IsochroneService } from 'src/app/isochrone-module/isochrone.service';
import { LoginSignupModalComponent } from 'projects/library-login-signup-module/src/lib/login-signup-modal/login-signup-modal.component';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
// import { LoginSignupModalComponent } from 'projects/library-login-signup-module/src/lib/login-signup-modal/login-signup-modal.component';

@Component({
  selector: 'app-add-new-user-modal',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule, FormsModule, MatInputModule, ReactiveFormsModule, MatOptionModule, MatSelectModule, FlexLayoutModule, MatButtonModule],
  templateUrl: './add-new-user-modal.component.html',
  styleUrls: ['./add-new-user-modal.component.css']
})
export class AddNewUserModalComponent implements OnInit {
  isLoggedin: any;

  constructor(public dialogRef: MatDialogRef<AddNewUserModalComponent>, private appAnalysisService: AppAnalysisService, private snackBar: MatSnackBar, private _isochroneService: IsochroneService,
    private MatDialogBox: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.isLoggedin = data
  }
  hide = true;
  email = new UntypedFormControl('', [Validators.required, Validators.email]);
  password1 = new UntypedFormControl('', Validators.required);
  name = new UntypedFormControl('', Validators.required);
  invitationLink = new UntypedFormControl('1');
  role: any = '';
  showErrorMessage = false;
  userLoader = false;
  planType

  getErrorMessage() {
    return this.email.hasError('required') ? 'You must enter a Email Address' :
      this.email.hasError('email') ? 'Not a valid email' :
        '';
  }
  ngOnInit() {

    this.appAnalysisService.getUserAnalysisPlan().subscribe((data) => {
      console.log("data left", data)
      this.planType = data.data.analysis.plan;
    });

  }
  closeAddNewUser() {
    this.dialogRef.close();
  }

  addUser() {

    if (!this.isLoggedin) {
      const dialogRef = this.MatDialogBox.open(LoginSignupModalComponent, {
        width: '75%',
        data: { loginModel: true }
      });
      dialogRef.afterClosed().subscribe(data => {
        if (data) {
          if (this.isLoggedin) {
            // let userName = JSON.parse(localStorage.currentUser).data.uname;
            // let userName = this.aut.getUserName();
            // this.router.navigateByUrl('/dashboard/pricing')
          }
        } else {
          this.dialogRef.close();

        }
      })
    }
    // this.dialogRef.close();
    if (this.isLoggedin) {

      this.userLoader = true;
      this.appAnalysisService.addMembers(this.name.value, this.email.value, this.role, this.invitationLink.value,
        this.password1.value).subscribe(data => {
          if (data.message == "Invalid Authorization Token") {
            this.userLoader = false;
            this.dialogRef.close();
          }
          if (data.data == "cannot add user limit exceeded") {

            // this.openSnackBar("Can't add user limit exceeded","snackbar-error","fail");

            // if(this.planType == 'FREE'){
            const dialogbox = this.MatDialogBox.open(PricingModalComponent, {
              data: { message: "Please Purchase a plan to Add Users", module: "users" }
            })
            this.dialogRef.close(true);
            dialogbox.afterClosed().subscribe(result => {
            })
            // }

          }
          else if (data.data == "User already exists") {
            this.showErrorMessage = true;
            this._isochroneService.openSnackBar(data.data, "snackbar-error", "success");
          } else if (data.http_code == 400) {
            this._isochroneService.openSnackBar(data.message, "snackbar-error", "success");
          }
          else if (data.data) {
            this.dialogRef.close(true);
            this._isochroneService.openSnackBar("New User Add Successfuly", "snackbar-success", "success");
          }

          this.userLoader = false;
        });
    }
  }



}
